import { Injectable } from '@angular/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

@Injectable()
export class MasksFactory {
	public decimalNumber(): any {
		return {
			mask: createNumberMask({
				prefix: '',
				suffix: '',
				allowDecimal: true,
				thousandsSeparatorSymbol: ' ',
				showMask: true,
				decimalSymbol: '.'
			})
		};
	}

	public integerNumber(): any {
		return {
			mask: createNumberMask({
				prefix: '',
				suffix: '',
				showMask: true,
				thousandsSeparatorSymbol: ' ',
				decimalSymbol: '.'
			})
		};
	}

	public bankAccountNumber(): any {
		return {
			showMask: true,
			mask: [
				/\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
				'-',
				/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
				'/',
				/\d/, /\d/, /\d/, /\d/
			]
		};
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/format.ts